<template>
  <v-btn
    :disabled="disabled"
    title="Cancel Cued Scenes in this Channel"
    @click="() => handleClear(props.channelUid)"
    variant="tonal"
    prepend-icon="mdi-close-thick">
    Cancel Cue
  </v-btn>
</template>
<script setup>
import { $http } from '../../../stores/http';

const props = defineProps(['disabled', 'channelUid']);
async function handleClear(channelUid) {
  await $http(
    'POST',
    `/dynamic_engine/cue/clear_all_cued_frames_in_channel/${channelUid}`
  );
}
</script>
<style scoped></style>
